import Login from "features/login/login";
import ForgotPassword from "features/forgotPassword/forgotPassword";
import SetPassword from "features/setPassword/setPassword";
import Dashboard from "features/dashboard/dashboard";
import ClientDetails from "features/clients/details/detail";
import ClientJobs from "features/clients/create/clientJobs/clientJobs";
import CreateClient from "features/clients/create/create";
import CommissionStatements from "features/billingCommissions/commission/commissionStatements/commissionStatements";
import Invoices from "features/billingCommissions/invoices/invoices";
import SubmitToBilling from "features/billingCommissions/submitToBilling/submitToBilling";
import BillingClients from "features/configurations/billingClients/billingClients";
import BillingJobs from "features/configurations/billingJobs/billingJobs";
import CommissionPlans from "features/configurations/commissionPlans/commissionPlans";
import CommissionPlansDetail from "features/configurations/commissionPlans/details/commissionPlansDetail";
import CreateCommissionPlans from "features/configurations/commissionPlans/createCommissionPlans";
import { LookupTables } from "features/configurations/lookupTables/lookupTables";
import RolesPermission from "features/configurations/rolesPermissions/rolesPermissions";
import CreateRolesPermission from "features/configurations/rolesPermissions/createRolesPermission/createRolesPermission";
import Users from "features/configurations/users/users";
import CreateUsers from "features/configurations/users/createUsers";
import ClientContacts from "features/configurations/clientContacts/clientContacts";
import NotFound from "features/notFound/notFound";
import Unauthorized from "features/unauthorized/unauthorized";
import GuestPageLayout from "layout/guestPageLayout";
import LoggedInPageLayout from "layout/loggedInPageLayout";
import UsersDetails from "features/configurations/users/userDetail";
import Candidates from "features/candidates/candidates";
import CandidatesDetails from "features/candidateDetails/candidateDetails";
import Profile from "features/profile/profile";
import K from "utilities/constants";
import { Jobs } from "features/jobs/jobs";
import Logs from "features/logs/logs";
import InvoiceDetails from "features/billingCommissions/invoices/invoiceDetails/invoiceDetails";
import Schedule from "features/billingCommissions/scheduledBillings/schedule";
import CommissionApprovalsPage from "features/billingCommissions/commission/commissionApprovalsPage/commissionApprovalsPage";
import CommissionStatementDetail from "features/billingCommissions/commission/commissionStatementDetail";
import PreviewUploads from "features/jobs/uploadCandidate/previewUpload";
import ClientClassDetails from "features/clients/details/classes/clientClassDetails/clientClassDetails";
import { Engagements } from "../features/engagements/engagements";
import {
  hasAtLeastOneAssignedClient,
  hasAtLeastOneClientWithEngagementMilestones,
} from "./extraConditions";
import { RecruiterPerformanceReporting } from "../features/reporting/recruiterPerformanceReporting";
import { ClientReporting } from "../features/reporting/clientReporting";
import { InternalReporting } from "../features/reporting/internalReporting";
import { Reports } from "../features/configurations/reports/reports";
import { Clients } from "../features/clients/clientsListing/clients";
import { CandidateWorkflow } from "../features/configurations/candidateWorkflow/candidateWorkflow";
import { RecruiterGoals } from "../features/configurations/recruiterGoals/recruiterGoals";
import { RootRedirect } from "./rootRedirect";
const routes = [
  {
    path: "/",
    name: "RootRedirect",
    exact: true,
    component: RootRedirect,
    authenticated: true,
    layout: LoggedInPageLayout,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    layout: GuestPageLayout,
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword,
    layout: GuestPageLayout,
  },
  {
    path: "/set-password",
    name: "SetPassword",
    component: SetPassword,
    layout: GuestPageLayout,
  },
  {
    path: "/clients",
    name: "Clients",
    exact: true,
    component: Clients,
    authenticated: true,
    extraCondition: hasAtLeastOneAssignedClient,
    layout: LoggedInPageLayout,
  },
  {
    path: "/dashboard",
    name: "Recruiter Dashboard",
    exact: true,
    component: Dashboard,
    authenticated: true,
    extraCondition: hasAtLeastOneAssignedClient,
    permission: [
      K.Permissions.ViewDashboardOwnProgress,
      K.Permissions.ViewDashboardTeamProgress,
    ],
    layout: LoggedInPageLayout,
  },
  {
    path: "/clients/create",
    name: "Create Client",
    exact: true,
    component: CreateClient,
    authenticated: true,
    extraCondition: hasAtLeastOneAssignedClient,
    permission: [K.Permissions.CreateClient],
    layout: LoggedInPageLayout,
  },
  {
    path: "/clients/:id",
    name: "Client Details",
    exact: true,
    authenticated: true,
    component: ClientDetails,
    extraCondition: hasAtLeastOneAssignedClient,
    layout: LoggedInPageLayout,
  },
  {
    path: "/clients/:clientId/class/:classId",
    name: "Client Class",
    authenticated: true,
    exact: true,
    component: ClientClassDetails,
    extraCondition: hasAtLeastOneAssignedClient,
    permission: [K.Permissions.ViewClass],
    layout: LoggedInPageLayout,
  },
  {
    path: "/clients/:clientId/class/:classId/:statusesId?/:statusName?/:subStatusesId?/:subStatusName?",
    name: "Client Class",
    authenticated: true,
    component: ClientClassDetails,
    extraCondition: hasAtLeastOneAssignedClient,
    permission: [K.Permissions.ViewClass],
    layout: LoggedInPageLayout,
  },
  {
    path: "/clients/:clientId/job/:jobId/:statusesId?/:statusName?/:subStatusesId?/:subStatusName?",
    name: "Client Jobs",
    authenticated: true,
    component: ClientJobs,
    extraCondition: hasAtLeastOneAssignedClient,
    layout: LoggedInPageLayout,
  },

  {
    path: "/profile",
    name: "Profile",
    authenticated: true,
    exact: true,
    component: Profile,
    layout: LoggedInPageLayout,
  },
  {
    path: "/jobs",
    name: "Jobs",
    authenticated: true,
    exact: true,
    component: Jobs,
    extraCondition: hasAtLeastOneAssignedClient,
    permission: [K.Permissions.ViewJobs],
    layout: LoggedInPageLayout,
  },
  {
    path: "/candidates/preview-upload",
    name: "PreviewUpload",
    authenticated: true,
    exact: true,
    component: PreviewUploads,
    extraCondition: hasAtLeastOneAssignedClient,
    permission: [K.Permissions.ViewJobs],
    layout: LoggedInPageLayout,
  },
  {
    path: "/candidates",
    name: "Candidates",
    authenticated: true,
    exact: true,
    component: Candidates,
    extraCondition: hasAtLeastOneAssignedClient,
    permission: [K.Permissions.ViewCandidates],
    layout: LoggedInPageLayout,
  },
  {
    path: "/candidates/detail/:id",
    name: "CandidateDetails",
    component: CandidatesDetails,
    authenticated: true,
    exact: true,
    extraCondition: hasAtLeastOneAssignedClient,
    permission: [K.Permissions.ViewCandidates],
    layout: LoggedInPageLayout,
  },
  {
    path: "/engagements",
    name: "Engagements",
    authenticated: true,
    exact: true,
    component: Engagements,
    extraCondition: hasAtLeastOneClientWithEngagementMilestones,
    permission: [
      K.Permissions.ManageEngagementsForAssignedCandidates,
      K.Permissions.ManageEngagementsForAssignedClients,
    ],
    layout: LoggedInPageLayout,
  },
  {
    path: "/reporting/recruiter-performance",
    name: "Recruiter Performance",
    authenticated: true,
    exact: true,
    component: RecruiterPerformanceReporting,
    permission: [K.Permissions.ViewRecruiterPerformanceReporting],
    layout: LoggedInPageLayout,
  },
  {
    path: "/reporting/client-reporting",
    name: "Client Reporting",
    authenticated: true,
    exact: true,
    component: ClientReporting,
    permission: [K.Permissions.ViewClientReporting],
    layout: LoggedInPageLayout,
  },
  {
    path: "/reporting/internal-reporting",
    name: "Internal Reporting",
    authenticated: true,
    exact: true,
    component: InternalReporting,
    permission: [K.Permissions.ViewInternalReporting],
    layout: LoggedInPageLayout,
  },
  {
    path: "/billings/commission-statement",
    name: "Commission Statements",
    authenticated: true,
    exact: true,
    component: CommissionStatements,
    extraCondition: hasAtLeastOneAssignedClient,
    permission: [K.Permissions.ViewCommissionStatement],
    layout: LoggedInPageLayout,
  },
  {
    path: "/billings/commission-statement/detail/:id",
    name: "Commission Statements",
    authenticated: true,
    exact: true,
    component: CommissionStatementDetail,
    extraCondition: hasAtLeastOneAssignedClient,
    permission: [K.Permissions.ViewCommissionStatement],
    layout: LoggedInPageLayout,
  },
  {
    path: "/billings/commission-approval",
    name: "Commission Approval",
    authenticated: true,
    component: CommissionApprovalsPage,
    extraCondition: hasAtLeastOneAssignedClient,
    permission: [K.Permissions.ViewCommissionApproval],
    layout: LoggedInPageLayout,
  },
  {
    path: "/billings/invoices",
    name: "Invoices",
    exact: true,
    authenticated: true,
    component: Invoices,
    extraCondition: hasAtLeastOneAssignedClient,
    permission: [K.Permissions.ViewInvoices],
    layout: LoggedInPageLayout,
  },
  {
    path: "/billings/invoices/detail/:id",
    name: "Invoice Details",
    exact: true,
    authenticated: true,
    component: InvoiceDetails,
    extraCondition: hasAtLeastOneAssignedClient,
    permission: [K.Permissions.ViewInvoices],
    layout: LoggedInPageLayout,
  },
  {
    path: "/billings/submit",
    name: "Submit To Billing",
    authenticated: true,
    component: SubmitToBilling,
    extraCondition: hasAtLeastOneAssignedClient,
    permission: [K.Permissions.ViewBillingApproval],
    layout: LoggedInPageLayout,
  },
  {
    path: "/billings/scheduled",
    name: "Scheduled Billing",
    authenticated: true,
    component: Schedule,
    extraCondition: hasAtLeastOneAssignedClient,
    permission: [K.Permissions.ViewScheduledBilling],
    layout: LoggedInPageLayout,
  },
  {
    path: "/configurations/billing-clients",
    name: "BillingClients",
    authenticated: true,
    component: BillingClients,
    permission: [K.Permissions.ViewBillingClients],
    layout: LoggedInPageLayout,
  },
  {
    path: "/configurations/billing-jobs",
    name: "Billingjobs",
    authenticated: true,
    component: BillingJobs,
    permission: [K.Permissions.ViewBillingJobs],
    layout: LoggedInPageLayout,
  },
  {
    path: "/configurations/lookup-tables",
    name: "LookupTables",
    authenticated: true,
    component: LookupTables,
    permission: [K.Permissions.ViewLookupTable],
    layout: LoggedInPageLayout,
  },
  {
    path: "/configurations/commission-plans/create",
    name: "Create Commission Plans",
    authenticated: true,
    exact: true,
    component: CreateCommissionPlans,
    permission: [K.Permissions.CreateCommissionPlan],
    layout: LoggedInPageLayout,
  },
  {
    path: "/configurations/commission-plans",
    name: "Commission Plans",
    authenticated: true,
    exact: true,
    component: CommissionPlans,
    permission: [K.Permissions.ViewCommissionPlan],
    layout: LoggedInPageLayout,
  },
  {
    path: "/configurations/commission-plans/detail/:planId",
    name: "Commission Plans Detail",
    authenticated: true,
    exact: true,
    component: CommissionPlansDetail,
    permission: [K.Permissions.ViewCommissionPlan],
    layout: LoggedInPageLayout,
  },
  {
    path: "/configurations/commission-plan/add-new/:planId",
    name: "Create Commission Plans",
    authenticated: true,
    exact: true,
    component: CreateCommissionPlans,
    permission: [K.Permissions.EditCommissionPlan],
    layout: LoggedInPageLayout,
  },
  {
    path: "/configurations/roles-permission",
    name: "RolesPermission",
    authenticated: true,
    exact: true,
    component: RolesPermission,
    permission: [K.Permissions.ViewRolesAndPermissions],
    layout: LoggedInPageLayout,
  },
  {
    path: "/configurations/roles-permission/create",
    name: "Create RolesPermission",
    authenticated: true,
    component: CreateRolesPermission,
    permission: [K.Permissions.CreateRole],
    layout: LoggedInPageLayout,
  },
  {
    path: "/configurations/roles-permission/edit/:id",
    name: "Edit RolesPermission",
    authenticated: true,
    component: CreateRolesPermission,
    permission: [K.Permissions.EditRolesAndPermissions],
    layout: LoggedInPageLayout,
  },
  {
    path: "/configurations/users",
    name: "Users",
    authenticated: true,
    exact: true,
    component: Users,
    permission: [K.Permissions.ViewUsers],
    layout: LoggedInPageLayout,
  },
  {
    path: "/configurations/users/create",
    name: "Create Users",
    component: CreateUsers,
    authenticated: true,
    exact: true,
    permission: [K.Permissions.ViewUsers],
    layout: LoggedInPageLayout,
  },
  {
    path: "/configurations/users/edit/:id",
    name: "Edit User",
    component: CreateUsers,
    authenticated: true,
    exact: true,
    permission: [K.Permissions.EditUser],
    layout: LoggedInPageLayout,
  },
  {
    path: "/configurations/users/detail/:id",
    name: "User Detail",
    component: UsersDetails,
    authenticated: true,
    exact: true,
    permission: [K.Permissions.ViewUsers],
    layout: LoggedInPageLayout,
  },
  {
    path: "/configurations/client-contacts",
    name: "Client Contacts",
    authenticated: true,
    component: ClientContacts,
    permission: [K.Permissions.ViewClientContacts],
    layout: LoggedInPageLayout,
  },
  {
    path: "/configurations/reports",
    name: "Reports",
    authenticated: true,
    component: Reports,
    permission: [K.Permissions.ManageReports],
    layout: LoggedInPageLayout,
  },
  {
    path: "/configurations/recruiter-goals",
    name: "Recruiter Goals",
    authenticated: true,
    component: RecruiterGoals,
    permission: [K.Permissions.ViewRecruiterGoals],
    layout: LoggedInPageLayout,
  },
  {
    path: "/configurations/workflow",
    name: "Candidate Workflow",
    authenticated: true,
    component: CandidateWorkflow,
    permission: [K.Permissions.ViewCandidateWorkflow],
    layout: LoggedInPageLayout,
  },
  {
    path: "/logs",
    name: "Logs",
    authenticated: true,
    component: Logs,
    exact: true,
    permission: [K.Permissions.ViewLogs],
    layout: LoggedInPageLayout,
  },
  {
    path: "/unauthorized",
    name: "Unauthorized",
    component: Unauthorized,
    authenticated: true,
    layout: GuestPageLayout,
  },
  {
    path: "*",
    name: "Not Found",
    component: NotFound,
    layout: GuestPageLayout,
  },
];

export default routes;
